import theme from 'src/theme';

export const tabsSx = {
    root: {
        bgcolor: theme.palette.common.white,
        borderRadius: '14px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(0,0,0,0.04)',
        overflow: 'hidden',
    },
    tabsHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        px: 2,
        pt: 1.5,
        pb: 0,
        borderBottom: `1px solid ${theme.palette.neutral[100]}`,
        flexWrap: 'wrap',
    },
    tabsGroup: {
        display: 'flex',
        gap: 0.5,
        flexWrap: 'wrap',
        alignItems: 'flex-end',
    },
    tab: {
        px: 2,
        py: 1.25,
        borderRadius: '8px 8px 0 0',
        fontSize: '0.82rem',
        fontWeight: 500,
        color: theme.palette.neutral[600],
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        transition: 'all 0.15s ease',
        borderBottom: '2px solid transparent',
        '&:hover': {
            color: theme.palette.neutral[800],
            bgcolor: theme.palette.neutral[50],
        },
    },
    tabActive: {
        px: 2,
        py: 1.25,
        borderRadius: '8px 8px 0 0',
        fontSize: '0.82rem',
        fontWeight: 600,
        color: theme.palette.primary.main,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        borderBottom: `2px solid ${theme.palette.primary.main}`,
    },
    search: {
        width: 220,
        mb: 1,
        // The header wraps below md, which drops the search onto a line of its own: 220px there
        // leaves two thirds of the line empty. Full width from that point down.
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
            fontSize: '0.85rem',
            bgcolor: theme.palette.neutral[50],
            '& fieldset': {borderColor: 'transparent'},
            '&:hover fieldset': {borderColor: theme.palette.neutral[200]},
            '&.Mui-focused fieldset': {
                borderColor: theme.palette.primary.main,
                borderWidth: '1px',
            },
        },
    },
    content: {
        p: 2,
    },
};
